export default __webpack_public_path__ + "static/media/STLInvestorsMeet.f53989b6.pdf";